<script setup>
import { WdsIcon, WdsPopup } from '@wds/components';
import { sustainabilityBadgeIcon } from '@/config/sustainability';

// ### COMPOSABLES
const { isExtraSmallScreen } = useMq();

// ### STORES
const sustainabilityStore = useSustainabilityStore();

const getSustainabilityInfo = computed(() => {
  const sustainabilityDetails = toValue(sustainabilityStore.getCurrentSustainabilityDetails);
  return {
    hasDetails: Boolean(sustainabilityDetails?.tier || sustainabilityDetails?.description),
    description: sustainabilityDetails?.description || '',
  };
});
</script>

<template>
  <WdsPopup
    v-if="getSustainabilityInfo.hasDetails"
    class="sustainability-popup"
    :is-open="sustainabilityStore.isSustainabilityPopupOpen"
    :has-header="false"
    :apply-sheet="isExtraSmallScreen"
    :sheet-height="0"
    :close-button="true"
    @popup-close="sustainabilityStore.toggleSustainabilityPopup(false)"
  >
    <template #popupContent>
      <div class="sustainability-details">
        <WdsIcon
          :asset="sustainabilityBadgeIcon"
          height="40"
          width="40"
          color="green"
        />
        <span class="sustainability-title">{{ $t('t_SUSTAINABILITYCERTIFIED') }}</span>
        <span
          v-if="getSustainabilityInfo.description"
          class="sustainability-description"
        >{{ getSustainabilityInfo.description }}</span>
      </div>
    </template>
  </WdsPopup>
</template>

<style scoped lang="scss">
.sustainability-details {
  display: flex;
  flex-direction: column;
  gap: $wds-spacing-m;
  align-items: center;
  padding: $wds-spacing-m;
  max-width: wds-rem(550px);

  .sustainability-title {
    @include title-5-bld;
  }

  .sustainability-description {
    @include body-1-reg;

    text-align: center;
  }

  @include tablet {
    padding: $wds-spacing-l 0;
  }
}
</style>
